import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // Thêm useNavigate

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState({ type: '', text: '' });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate(); // Khai báo navigate
    const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage({ type: '', text: '' });

        try {
            const res = await fetch(`${API_URL}/api/auth/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message);

            setMessage({ type: 'success', text: 'Đã gửi mã OTP! Đang chuyển hướng...' });
            
            // ✅ Đẩy email sang trang ResetPassword sau 1.5 giây
            setTimeout(() => {
                navigate('/reset-password', { state: { email } });
            }, 1500);

        } catch (error) {
            setMessage({ type: 'error', text: error.message });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex justify-center items-center pt-24 pb-12 px-4">
            <div className="max-w-md w-full bg-white p-8 rounded-2xl shadow-sm border border-gray-100 text-center">
                    <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="material-symbols-outlined text-3xl">lock_reset</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Quên mật khẩu?</h2>
                <p className="text-gray-500 text-sm mb-6">Đừng lo lắng! Hãy nhập email bạn đã đăng ký, chúng tôi sẽ gửi mã OTP để bạn đặt lại mật khẩu mới.</p>

                {message.text && (
                    <div className={`p-4 mb-6 rounded-lg text-sm font-medium ${message.type === 'success' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
                        {message.text}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-5">
                    <input 
                        type="email" 
                        required 
                        placeholder="Nhập địa chỉ Email"
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        className="w-full p-3 bg-gray-50 border border-gray-200 rounded-lg text-gray-900 focus:outline-none focus:border-blue-500" 
                    />
                    <button type="submit" disabled={isLoading} className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg transition-colors">
                        {isLoading ? 'Đang gửi...' : 'Gửi yêu cầu'}
                    </button>
                </form>

                <div className="mt-6">
                    <Link to="/login" className="text-sm font-semibold text-gray-500 hover:text-blue-600 flex items-center justify-center gap-1">
                        <span className="material-symbols-outlined text-sm">arrow_back</span> Quay lại đăng nhập
                    </Link>
                </div>
            </div>
        </div>
    );
}